var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as moment from 'moment-timezone';
/**
 * This is a legal requirement that we do not allow order history download prior to April 1 2021
 * this util func can be removed in Sept 2021
 * https://doordash.atlassian.net/browse/DDC-1994
 * @param orderHistoryMonths
 * @returns
 */
export var filterOrderHistoryBeforeApr2021 = function (orderHistoryMonths) {
    var YEAR_2021 = '2021'; // YYYY format
    var APRIL = '04'; // MM format
    return orderHistoryMonths.filter(function (_a) {
        var startDate = _a.startDate;
        var _b = __read(startDate.split('-'), 3), year = _b[0], month = _b[1], _ = _b[2];
        if (year < YEAR_2021) {
            return false;
        }
        if (year > YEAR_2021) {
            return true;
        }
        return (parseInt(month, 10) || -1) >= parseInt(APRIL, 10);
    });
};
export var getOrderHistoryMonths = function () {
    var lastFourMonths = [];
    var date = moment();
    for (var i = 0; i < 4; i++) {
        var endDate = date.clone().endOf('month');
        if (date.month() === moment().month()) {
            // current month
            if (date.isSame(date.clone().startOf('month'), 'day')) {
                // if today is the first of the month, skip current month from displaying
                date.subtract(1, 'months');
                continue;
            }
            endDate = moment().subtract(1, 'days');
        }
        var monthData = {
            monthString: date.format('MMMM, YYYY'),
            startDate: date.clone().startOf('month').format('YYYY-MM-DD'),
            endDate: endDate.format('YYYY-MM-DD'),
        };
        lastFourMonths.push(monthData);
        date.subtract(1, 'months');
    }
    return filterOrderHistoryBeforeApr2021(lastFourMonths);
};
